module.exports = __webpack_public_path__ + "static/media/MomStrong-41.af06f8c5.jpg";